import { Star, ExternalLink } from "lucide-react";
import FadeIn from "@/components/FadeIn";

export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps?cid=17013616113132345525";

const RATING_LABEL = "EXCELLENT";
const REVIEW_COUNT = 14;

// Avis Google réels (source : fiche Google Ener Solutions, via widget Trustindex du site officiel)
const REVIEWS = [
  {
    name: "yohan bilski",
    text: "Une équipe qui est professionnel et disponible. Aide administratif comme on en fait plus, cela nous a aidé énormément. Le technicien a fait du très bon travail avec suivi réactif (mise en service, explications, intervention réglage après la pose). On peut leur faire confiance, tout a été bien expliqué dès le premier RDV, pas de surprise. Merci à toute l'équipe pour ce travail (remplacement chaudière à gaz par système PAC AIR/EAU + 1 cumulus).",
  },
  {
    name: "Catherine CHAROT",
    text: "Youssef et Mickael tellement professionnels, travail soigné et quel boulot, 1 jour et demi à fond sans s'arrêter quels bosseurs ! Aujourd'hui 8h 21h et toutes les explications et vérifications. Eau chaude ce soir et chauffage top, je suis ravie… Bravo les garçons",
  },
  {
    name: "Famille Almon",
    text: "Personnel très compétent, professionnel, horaires et durée d'installation respectés. Tarifs raisonnables. Proposition de solutions d'économie d'énergie sans pousser à la vente, conseils pertinents. A recommander sans hésitation.",
  },
  {
    name: "Lagrange jp",
    text: "Tout fonctionne bien un an après l'installation de ma clim réversible dans les combles aménagées. Résultat efficace et économique. L'équipe est réactive, à l'écoute et très disponible : j'ai demandé récemment le déplacement d'un des deux split à l'étage inférieur, la modification a été réalisée dans des délais rapides. Je recommande !",
  },
  {
    name: "Jass COOWAR",
    text: "Une expérience sans couture : l'équipe de Ener Solutions est venue m'installer des panneaux solaires (24 panneaux) et ont su se montrer très pédagogues avec une excellente maîtrise du sujet sur les gains réels dans la consommation énergétique et sur l'autoconsommation. Merci encore pour votre réactivité, votre dynamisme et surtout votre professionnalisme ! Je recommande les yeux fermés",
  },
  {
    name: "jean claude Arias",
    text: "Réactif, de bon conseil, et un travail de qualité. Je recommande",
  },
  {
    name: "Jeannine Honnet",
    text: "Merci à Youssef pour sa gentillesse, son professionnalisme, ses explications claires sur l'installation.",
  },
  {
    name: "COMPADRE S",
    text: "Professionnel, rapide, propre... Exactement ce qu'il faut quand on cherche une bonne entreprise !",
  },
  {
    name: "Elee Chady",
    text: "Un super travail de qualité et très professionnel ! Merci au dynamisme de Youssef pour son travail de qualité",
  },
  {
    name: "Philippe PORTALIER",
    text: "Bon travail, installateurs très sympathiques",
  },
];

const THEMES = {
  dark: {
    section: "border-y border-white/10 bg-forest-dark",
    eyebrow: "text-emerald-400",
    title: "text-white",
    badge: "border-white/10 shadow-glow",
    card: "border-white/10 bg-forest-surface/80 hover:border-emerald-400/40",
    text: "text-white/80",
    name: "text-white",
    meta: "text-white/45",
    avatar: "bg-emerald-400/15 text-emerald-300",
    divider: "border-white/10",
    footer: "text-white/40",
    link: "decoration-emerald-400/60 hover:text-emerald-300",
  },
  light: {
    section: "border-y border-glacier-border bg-glacier",
    eyebrow: "text-ice",
    title: "text-ink",
    badge: "border-glacier-border shadow-card",
    card: "border-glacier-border bg-white shadow-sm hover:border-ice/40",
    text: "text-slate-600",
    name: "text-ink",
    meta: "text-slate-400",
    avatar: "bg-ice-light text-ice",
    divider: "border-glacier-border",
    footer: "text-slate-400",
    link: "decoration-ice/60 hover:text-ice",
  },
};

const GoogleG = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

const Stars = ({ className = "h-3.5 w-3.5" }) => (
  <span className="flex items-center gap-0.5" aria-label="5 étoiles sur 5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`${className} fill-amber-400 text-amber-400`} />
    ))}
  </span>
);

const ReviewCard = ({ r, idx, t }) => (
  <article
    data-testid={`review-card-${idx}`}
    className={`flex w-[320px] shrink-0 flex-col justify-between rounded-2xl border p-6 backdrop-blur-sm transition-colors duration-300 sm:w-[380px] ${t.card}`}
  >
    <div>
      <div className="flex items-center justify-between">
        <Stars />
        <GoogleG className="h-4 w-4" />
      </div>
      <p className={`mt-4 overflow-hidden text-sm leading-relaxed [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:7] ${t.text}`}>
        « {r.text} »
      </p>
    </div>
    <div className={`mt-6 flex items-center gap-3 border-t pt-4 ${t.divider}`}>
      <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full font-display text-sm font-bold ${t.avatar}`}>
        {r.name.charAt(0)}
      </span>
      <div className="min-w-0">
        <p className={`truncate font-display text-sm font-bold ${t.name}`}>{r.name}</p>
        <p className={`truncate font-mono text-[10px] uppercase tracking-wider ${t.meta}`}>
          Avis Google · 5/5
        </p>
      </div>
    </div>
  </article>
);

const Row = ({ hidden, t }) => (
  <div aria-hidden={hidden} className="flex shrink-0 gap-5 pr-5">
    {REVIEWS.map((r, i) => (
      <ReviewCard key={i} r={r} idx={hidden ? `dup-${i}` : i} t={t} />
    ))}
  </div>
);

export default function Reviews({ variant = "dark" }) {
  const t = THEMES[variant] || THEMES.dark;
  return (
    <section
      id="avis"
      data-testid="section-avis"
      className={`relative overflow-hidden py-24 sm:py-32 ${t.section}`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <FadeIn>
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p className={`font-mono text-[11px] font-semibold uppercase tracking-[0.25em] sm:text-xs ${t.eyebrow}`}>
                Ils nous font confiance
              </p>
              <h2 className={`mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-5xl ${t.title}`}>
                Nos clients en parlent mieux que nous.
              </h2>
            </div>

            <a
              data-testid="google-rating-badge"
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex w-fit items-center gap-4 rounded-2xl border bg-white px-5 py-4 text-ink transition-transform duration-300 hover:-translate-y-0.5 ${t.badge}`}
            >
              <GoogleG className="h-9 w-9" />
              <div>
                <div className="flex items-center gap-2">
                  <span
                    data-testid="google-rating-label"
                    className="font-display text-lg font-extrabold tracking-tight"
                  >
                    {RATING_LABEL}
                  </span>
                  <Stars className="h-4 w-4" />
                </div>
                <p
                  data-testid="google-review-count"
                  className="mt-0.5 flex items-center gap-1.5 text-xs font-medium text-slate-500"
                >
                  Basé sur {REVIEW_COUNT} avis Google
                  <ExternalLink className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
                </p>
              </div>
            </a>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.1} className="mt-14">
        <div
          data-testid="reviews-carousel"
          className="relative"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 6%, black 94%, transparent)",
          }}
        >
          <div className="flex w-max animate-[marquee_110s_linear_infinite] hover:[animation-play-state:paused]">
            <Row t={t} />
            <Row hidden t={t} />
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.15}>
        <p className={`mx-auto mt-10 max-w-7xl px-5 text-center text-xs sm:px-8 ${t.footer}`}>
          Avis publiés sur Google par nos clients.{" "}
          <a
            data-testid="google-reviews-link"
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`underline underline-offset-4 transition-colors ${t.link}`}
          >
            Voir tous les avis sur Google
          </a>
        </p>
      </FadeIn>
    </section>
  );
}
